import BaseService from "../../base/base_service";
import ISpinnerProxyService from "./spinner_proxy_service.interface";
import {ISpinnerService} from "../../../../common/interfaces/spinner.service.interface";

interface SpinnerProxyServiceParams {
    getSpinnerService: () => ISpinnerService;
}

export default class SpinnerProxyService extends BaseService implements ISpinnerProxyService {
    static CLASS = 'SpinnerProxyService';
    private _params: SpinnerProxyServiceParams;

    init(params: SpinnerProxyServiceParams) {
        this._params = params;
    }

    startSpinner(isMigrationSpinner?: boolean): void {
        return this._params.getSpinnerService().startSpinner(isMigrationSpinner);
    }

    stopSpinner(): void {
        return this._params.getSpinnerService().stopSpinner();
    }
}